import React from "react"

import { Grid, IconButton, Link, Popover, Tooltip, Typography } from "@material-ui/core"
import { Info } from "@material-ui/icons"
import { TrackableLinkInteraction } from "@/protocols/trackableLinks"

import useStyles from "@/pages/Admin/TrackableLinks/TrackableLinkMetricsV2/TrackableLinkInteractions/TrackableLinkInteractionClient/styles"
import useContactDisplay from "@/hooks/useContactDisplay"
import { buildChatLink } from "@/utils/chat"

type TrackableLinkInteractionClientType = "nickname" | "phone"
type TrackableLinkInteractionClientProps = {
	client: TrackableLinkInteraction["client"]
	type: TrackableLinkInteractionClientType
}

type TrackableLinkInterationClientTypeToClientDisplayValue = {
	nickname: string | undefined
	phone: React.ReactElement | undefined
}

const TrackableLinkInteractionClient: React.FC<TrackableLinkInteractionClientProps> = (props) => {
	const { client, type } = props
	const [popoverAnchorElement, setPopoverAnchorElement] = React.useState<HTMLElement | null>(null)
	const [isPopoverOpen, setIsPopoverOpen] = React.useState(false)

	const classes = useStyles()
	const { getDisplayPhoneNumber } = useContactDisplay()

	const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setPopoverAnchorElement(event.currentTarget)
		setIsPopoverOpen(true)
	}

	const handlePopoverClose = () => {
		setPopoverAnchorElement(null)
		setIsPopoverOpen(false)
	}

	function getClientDisplayValue () {
		const chatLink = buildChatLink(client?.id)

		const trackableLinkInterationClientMap: TrackableLinkInterationClientTypeToClientDisplayValue = {
			nickname: client?.nickname,
			phone: (
				<Tooltip title="Abrir conversa no Inbox da Letalk">
					<Link
						href={chatLink}
						target="_blank"
					>
						{getDisplayPhoneNumber(client?.phoneNumber)}
					</Link>
				</Tooltip>
			)
		}

		return trackableLinkInterationClientMap[type] || ""
	}

	function renderComponent () {
		if (client) {
			return (
				<>
					{getClientDisplayValue()}
				</>
			)
		}

		return (
			<>
				<IconButton
					style={{ padding: 0 }}
					aria-owns={isPopoverOpen ? "mouse-over-popover" : undefined}
					aria-haspopup="true"
					onClick={handlePopoverOpen}
				>
					<Info fontSize="small" color="disabled" />
				</IconButton>
				<Popover
					id="mouse-over-popover"
					open={isPopoverOpen}
					onClose={handlePopoverClose}
					anchorEl={popoverAnchorElement}
					classes={{
						paper: classes.popover
					}}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "center"
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "center"
					}}>
					<Grid container direction="column" spacing={2}>
						<Grid item>
							<Typography variant="h5" className={classes.popoverTitle}>
								Como identificamos o cliente?
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body2">
								A mensagem que você adicionou ao criar o link contém um código invisível, que usamos para identificar de qual link o cliente veio. Quando a mensagem é enviada, nosso sistema detecta esse código e associa ao link utilizado, rastreando a origem do contato sem alterar o conteúdo visível.
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body2">
								Se precisar de mais detalhes, estamos à disposição! 😊
							</Typography>
						</Grid>
					</Grid>
				</Popover>
			</>
		)
	}

	return (
		<Grid container>
			<Grid item xs={12}>
				{renderComponent()}
			</Grid>
		</Grid>
	)
}

export default TrackableLinkInteractionClient
